import React from 'react';
import { Tooltip } from '@mui/material';

import { ToolTipProps } from './types';

export default function CustomTooltip({
  title,
  children,
  arrow = true,
  placement = 'bottom',
  light = false,
  show = true,
  opened,
  tooltipStyle = {},
  fitWidth = false,
  ...rest
}: ToolTipProps) {
  if (!show) return <>{children}</>;

  return (
    <Tooltip
      title={title}
      open={opened}
      componentsProps={{
        tooltip: {
          sx: {
            borderRadius: '8px !important',
            fontSize: '12px !important',
            lineHeight: '16px !important',
            fontWeight: '400 !important',
            padding: '8px !important',
            fontFamily: 'Poppins, sans-serif !important',
            wordBreak: 'break-word',
            ...(light
              ? {
                  backgroundColor: '#ffffff !important',
                  color: '#353535 !important',
                  fontWeight: '400 !important',
                  width: '260px !important',
                  height: '50px !important',
                  display: 'flex !important',
                  justifyContent: 'center !important',
                  alignItems: 'center !important',
                  fontSize: '15px !important',
                  boxShadow: '1px 1px 8px 0px rgba(115, 87, 233, 0.30) !important',
                }
              : {
                  backgroundColor: 'var(--neutral-n-900) !important',
                  color: '#fff',
                }),
            ...tooltipStyle,
            ...(fitWidth ? { maxWidth: 'fit-content !important' } : {}),
          },
        },
        arrow: {
          sx: {
            color: light ? '#ffffff !important' : 'var(--neutral-n-900) !important',
          },
        },
      }}
      arrow={arrow}
      placement={placement}
      {...rest}>
      {children}
    </Tooltip>
  );
}
